import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import Navbar from 'client/components/Navbar';

import SrDataTableAdminPartners from 'client/components/SrDataTableAdminPartners';
import SrUserSettingFilterListDropdown from 'client/components/SrUserSettingFilterListDropdown';

import branch from 'client/core/branch';
import { SCREEN_ID_ADMIN_PARTNERS_REVIEW } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import AccountManagerActions from 'client/actions/AccountManager';
import SalesRepActions from 'client/actions/SalesRep';
import SrUserSettingPartnerTypeDropdown from 'client/components/SrUserSettingPartnerTypeDropdown';
import { DATA_TABLE_VIEW_ID_ADMIN_PARTNERS_REVIEW } from 'common/dataTableConstants';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_PARTNERS_REVIEW)
@withScrollToTop
@branch({
  appUrl: ['env', 'APP_URL'],
  currentUser: ['currentUser'],
  accountManagersList: ['accountManagers', 'listWithPartners'],
  salesReps: ['salesReps'],
})
class AdminReviewPartnersPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Admin Review Partner | Sunroom Rentals',
    section: 'Admin Review Partner',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    accountManagersList: PropTypes.array.isRequired,
    salesReps: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
  };

  static fetchData(match, inject) {
    return Promise.all([
      AccountManagerActions.getListWithPartners(inject),
      SalesRepActions.getSalesRepList(inject),
    ]);
  }

  render() {
    const { dispatch, currentUser, accountManagersList, salesReps, location } = this.props;

    return (
      <div className="page-admin">
        <div className={classnames('adminContainer', 'adminLargeContainer')}>
          <Navbar />
          <div className="section">
            <span className="headline">Partners Needing Review</span>
            <div className="actionsSection">
              <div className="filtersSection">
                <div className="filter">
                  <SrUserSettingFilterListDropdown
                    currentUser={currentUser}
                    settingField="adminPartners.accountManagerUserId"
                    placeholder="Account Manager"
                    optionsList={accountManagersList}
                  />
                </div>
                <div className="filter">
                  <SrUserSettingFilterListDropdown
                    currentUser={currentUser}
                    settingField="adminPartners.salesRepUserId"
                    placeholder="Sales Rep"
                    optionsList={salesReps}
                  />
                </div>
                <div className="filter">
                  <SrUserSettingPartnerTypeDropdown
                    currentUser={currentUser}
                    settingField="adminPartners.partnerType"
                    dispatch={dispatch}
                  />
                </div>
              </div>
            </div>
            <SrDataTableAdminPartners
              dispatch={dispatch}
              currentUser={currentUser}
              adminPartnerViewId={DATA_TABLE_VIEW_ID_ADMIN_PARTNERS_REVIEW}
              location={location}
              isReview
            />
          </div>
        </div>
      </div>
    );
  }
}

AdminReviewPartnersPage.displayName = 'AdminReviewPartnersPage';

export default AdminReviewPartnersPage;
